import { useConfigContext } from "@/state/configContext";
import { router } from "@/main";
import { server } from "@/state/server";
import type { Subida } from "@/state/types";

export function Subidas({
  subidas,
  admin = false,
}: {
  subidas: Subida[];
  admin?: boolean;
}) {
  const config = useConfigContext();

  return (
    <div className="container main">
      <div className="table-responsive">
        <table className="table subidas">
          <thead>
            <tr>
              <th />
              <th>Subida</th>
              <th>Hora</th>
              <th>Fotografo</th>
              <th>Fotos</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {subidas.map((subida) => {
              const f = config.fotografos[subida.fotografo_id];
              return (
                <tr
                  key={subida.id}
                  onClick={() =>
                    router.navigate({
                      to: admin ? "/admin/fotos" : "/buscador",
                      search: { subida_id: subida.id },
                    })
                  }
                >
                  <td>
                    <i
                      className={"fa fa-circle"}
                      style={{ color: subida.color }}
                    />
                  </td>
                  <td>{subida.id}</td>
                  <td>{subida.fecha}</td>
                  <td>{f.nombre}</td>
                  <td>
                    {" "}
                    {subida.subidas}/{subida.total}
                  </td>
                  <td>{subida.estado}</td>
                  {admin ? (
                    <td>
                      <a href={`${server}/admin/subida_log/${subida.id}`}>LOG</a>
                    </td>
                  ) : null}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
